import script from "./CursorTrail.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorTrail.vue?vue&type=script&setup=true&lang=js"

import "./CursorTrail.vue?vue&type=style&index=0&id=338ae5ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338ae5ca"]])

export default __exports__